const prefix = '/web/v1';

export const API_COLUMN_SETTING = {
  url: `${prefix}/grid/get-columns`,
  method: 'post',
};

export const COMMENT_UPSERT = {
  method: 'post',
  url: '/admin/diamond-comment/upsert',
};

export const DIAMOND_TRACK_DELETE = {
  method: 'post',
  url: '/admin/diamond-track/delete',
  showLoader: true,
};

export const NOTE_DELETE = {
  method: 'post',
  url: `${prefix}/diamond-comment/delete`,
  showLoader: true,
};

export const HIT_COUNTER = {
  method: 'post',
  url: '/admin/diamond/hit-counter',
  showLoader: true,
};

export const GET_DISCOUNT_CALC = {
  method: 'post',
  url: `${prefix}/diamond/get-discount-calculations`,
  showLoader: true,
};

export const GET_DASHBOARD_DATA = {
  method: 'post',
  url: `${prefix}/user/dashboard`,
  showLoader: true,
};

export const GET_MYPURCHASE_DATA = {
  method: 'post',
  url: `${prefix}/memo/paginate`,
};

export const SEARCH_DIAMOND_LIST = {
  method: 'post',
  url: `${prefix}/diamond/paginate`,
};

export const SEARCH_LIST = {
  method: 'post',
  url: `${prefix}/diamond/search/list`,
  showLoader: true,
};

export const CREATE_SAVED_SEARCH = {
  method: 'post',
  url: `${prefix}/diamond/search/upsert`,
  showLoader: true,
};

export const CREATE_MATCH_PAIR = {
  method: 'post',
  url: `${prefix}/match-pair/diamond/filter`,
  showLoader: true,
};

export const SELECT_SEARCH = {
  method: 'post',
  url: `${prefix}/diamond/search/list`,
  showLoader: true,
};

export const CREATE_DEMAND = {
  method: 'post',
  url: `${prefix}/diamond/search/upsert`,
  showLoader: true,
};

export const FETCH_CONFIRM_STONE = { url: `${prefix}/memo/paginate`, method: 'post', showLoader: true };

export const FETCH_DIAMOND_TRACK = {
  method: 'post',
  url: `${prefix}/diamond-track/paginate`,
  showLoader: true,
};

export const FETCH_NOTES = {
  method: 'post',
  url: `${prefix}/diamond-comment/by-user`,
  showLoader: true,
};

export const CREATE_TRACK = {
  method: 'post',
  url: `${prefix}/diamond-track/create`,
  showLoader: true,
};

export const UPDATE_TRACK = {
  method: 'post',
  url: `${prefix}/diamond-track/update`,
  showLoader: true,
};

export const COUNTER_OFFER = {
  method: 'post',
  url: `${prefix}/diamond-track/counter-offer`,
  showLoader: true,
};

export const PRINT_PDF = {
  method: 'post',
  url: `${prefix}/diamond/pdf`,
  showLoader: true,
};

export const EXPORT_EXCEL = {
  method: 'post',
  url: `${prefix}/diamond/excel`,
  showLoader: true,
};

export const EXPORT_FULL_STOCK_EXCEL = {
  method: 'get',
  url: `${prefix}/download-full-stock`,
  showLoader: true,
};

export const CONFIRM_STONE = {
  method: 'post',
  url: `${prefix}/diamond-confirm/request`,
  showLoader: true,
};

export const DELETE_TRACK = {
  method: 'post',
  url: `${prefix}/diamond-track/delete`,
  showLoader: true,
};

export const NOTE_UPSERT = {
  method: 'post',
  url: '/web/v1/diamond-comment/upsert',
  showLoader: true,
};

export const SEND_EMAIL_XRAY = {
  method: 'post',
  url: `${prefix}/diamond/x-ray-mail`,
};

export const VIEW_DIAMOND = {
  method: 'post',
  url: '/web/v1/diamond/view',
  showLoader: true,
};

export const DELETE_SEARCH = {
  method: 'post',
  url: '/web/v1/diamond/search/delete',
};

export const VERIFY_FINGER_PRINT = {
  method: 'post',
  url: `${prefix}/verifyfingerprint`,
};

export const RESENT_FP_OTP = {
  method: 'post',
  url: `${prefix}/resend-fp-otp`,
};

export const DIAMOND_DATA_BY_ID = {
  method: 'post',
  url: `${prefix}/diamond/search/by-id`,
};

export const VERIFY_MAIL = {
  method: 'post',
  url: `${prefix}/auth/verify-email`,
};

export const GET_BANNERS = {
  method: 'post',
  url: `${prefix}/banner/paginate`,
  showLoader: true,
};

export const DELETE_SEARCHED_DIAMOND = {
  method: 'post',
  url: `${prefix}/diamond/search/delete`,
};

export const QUICK_SEARCH = {
  method: 'post',
  url: `${prefix}/diamond/quick-search`,
};

export const GET_DIAMOND_DATA = {
  method: 'post',
  url: `${prefix}/diamond/paginate`,
};

export const RESET_PWD_BYUSER = {
  method: 'post',
  url: `${prefix}/auth/reset-password-by-user`,
};

export const GET_COUNTRY_LIST = {
  method: 'post',
  url: `${prefix}/country/paginate`,
  showLoader: true,
};

export const GET_STATE_LIST = {
  method: 'post',
  url: `${prefix}/state/paginate`,
  showLoader: true,
};

export const GET_CITY_LIST = {
  method: 'post',
  url: `${prefix}/city/paginate`,
  showLoader: true,
};

export const GET_USER_PROFILE = {
  method: 'post',
  url: `${prefix}/user/profile`,
};

export const UPDATE_USER_PROFILE = {
  method: 'post',
  url: `${prefix}/account/update`,
  showLoader: true,
};

export const ACCOUNT_UPDATE_KYC = {
  method: 'put',
  url: `${prefix}/account/`,
  showLoader: true,
};

export const UPLOAD_FILE = {
  method: 'post',
  url: `${prefix}/upload-file`,
  showLoader: true,
};

export const USER_SETTING_LIST = {
  method: 'post',
  url: `${prefix}/user-setting/paginate`,
  showLoader: true,
};

export const USER_SETTING_UPSERT = {
  method: 'post',
  url: `${prefix}/user-setting/upsert`,
  showLoader: true,
};

export const OFFER_SETTING_VIEW = {
  method: 'post',
  url: `${prefix}/setting/view`,
  showLoader: true,
};

export const FETCH_USER = {
  method: 'post',
  url: `${prefix}/user/view`,
};

export const ADMIN_UPDATE_USER = {
  method: 'put',
  url: `${prefix}/user/update`,
  showLoader: true,
};

export const FORGOT_PASSWORD = {
  method: 'post',
  url: `${prefix}/auth/forgot-password`,
};

export const LOGIN_USER = {
  method: 'post',
  url: `${prefix}/auth/login`,
  showLoader: true,
};

export const GUEST_LOGIN_USER = {
  method: 'post',
  url: `${prefix}/guest/auth/login`,
  showLoader: true,
};

export const RESEND_VERIFY_MAIL = {
  method: 'post',
  url: `${prefix}/user/resend-verification-email`,
};

export const UPDATE_USER_TOKEN = {
  method: 'post',
  url: `${prefix}/auth/update-token`,
};

export const PWD_RESET = {
  method: 'post',
  url: `${prefix}/auth/reset-password`,
};

export const FETCH_SELLERS = {
  method: 'post',
  url: `${prefix}/register/sellers`,
};

export const SIGNUP_USER_FRONT = {
  method: 'post',
  url: `${prefix}/register/register`,
  showLoader: true,
};

export const DIAMOND_XRAY_MAIL = {
  method: 'post',
  url: `${prefix}/diamond/x-ray-mail`,
};

export const CREATE_ANALYTICS = {
  method: 'post',
  url: `${prefix}/analytics/create`,
};

export const USER_LOGOUT = {
  method: 'post',
  url: `${prefix}/auth/logout`,
};

export const FEATURE_STONE = {
  method: 'post',
  url: `${prefix}/featuredStone/paginate`,
  showLoader: true,
};

export const DOWNLOAD_ZIP = {
  method: 'post',
  url: `${prefix}/diamond/download-zip`,
  showLoader: true,
};

export const DOWNLOAD_CERTIFICATE = {
  method: 'post',
  url: `${prefix}/diamond/download-certificate`,
  showLoader: true,
};

export const DOWNLOAD_FILE = {
  method: 'post',
  url: `${prefix}/download-file`,
  showLoader: true,
};

export const DIAMOND_FTC = {
  method: 'post',
  url: `${prefix}/diamond/diamond-ftc`,
};

export const CREATE_SCHEDULE = {
  method: 'post',
  url: `${prefix}/cabin-schedule/create`,
  showLoader: true,
};

export const GET_NOTIFICATIONS = {
  method: 'post',
  url: `${prefix}/notification/list`,
};

export const GET_EVENTS = {
  method: 'post',
  url: `${prefix}/event/paginate`,
};

export const PROJECT_SETTING = {
  method: 'post',
  url: `${prefix}/project-setting/view`,
};

export const MARK_AS_READ = {
  method: 'post',
  url: `${prefix}/notification/markAsRead`,
};

export const GET_SLOTS = {
  method: 'post',
  url: `${prefix}/cabin-slot/paginate`,
};

export const FETCH_OFFICE_DIAMOND = {
  method: 'post',
  url: `${prefix}/cabin-schedule/list`,
  showLoader: true,
};

export const GET_TRACK_SHIPMENTS = {
  method: 'post',
  url: `${prefix}/shipping-detail/paginate`,
  showLoader: true,
};

export const GET_SHIPMENT_DETAILS = {
  method: 'post',
  url: `${prefix}/shipping-detail`,
  showLoader: true,
};

export const GET_MASTERS = {
  method: 'post',
  url: `${prefix}/master/list-by-code-no-auth`,
};

export const DELETE_OFFICE_DIAMOND = {
  method: 'post',
  url: `${prefix}/cabin-schedule/destroyDiamondAndSlot`,
};

export const GET_NEWS_DATA = {
  method: 'post',
  url: `${prefix}/news/paginate`,
  showLoader: true,
};

export const TAKE_APPOINTMENT = {
  method: 'post',
  url: `${prefix}/cabin-schedule/create-data`,
  showLoader: true,
};

export const CONTACT_US = {
  method: 'post',
  url: `${prefix}/contactus/create`,
  showLoader: true,
};

export const QUOTE_DAY_LIST = {
  method: 'post',
  url: `${prefix}/show-selection/paginate`,
  showLoader: true,
};

export const SEARCH_STONES_BY_ID = {
  method: 'post',
  url: `${prefix}/diamond/search/by-id`,
  showLoader: true,
};

export const GET_CITY_SEARCH = {
  method: 'post',
  url: `${prefix}/city/search`,
  showLoader: true,
};

export const BLOCK_MASTERS = {
  method: 'post',
  url: `${prefix}/diamond-block-master/paginate`,
};

export const API_CALCULATE_PRICE = {
  method: 'post',
  url: `${prefix}/rap-price/paginate`,
};

export const ADD_HOLD = {
  method: 'post',
  url: `${prefix}/diamond-block/create`,
};

export const GET_BLOCK_DIAMONDS = {
  method: 'post',
  url: `${prefix}/diamond-block/paginate`,
  showLoader: true,
};

export const DIAMOND_TRACK_STATUS_UPDATE = {
  method: 'post',
  url: `${prefix}/diamond-track/status-update`,
  showLoader: true,
};

export const GET_SERVER_TIME = {
  method: 'get',
  url: `${prefix}/common/server-time?${Math.random()}`,
};

export const GET_EXCLUSIVE_COLLECTION = {
  method: 'post',
  url: `${prefix}/diamond/exclusive-search/list`,
  showLoader: true,
};

export const GET_SETTING = {
  method: 'post',
  url: `admin/v1/setting/view`,
};

export const BID_CONFIG = {
  method: 'get',
  url: `${prefix}/diamond-bid/dynamic-bid-config`,
};

export const CREATE_BID_CART = {
  method: 'post',
  url: `${prefix}/bid-cart/create`,
  showLoader: true,
};

export const BID_CART_PAGINATE = {
  method: 'post',
  url: `${prefix}/bid-cart/paginate`,
  showLoader: true,
};

export const BID_PAGINATE = {
  method: 'post',
  url: `${prefix}/dynamic-diamond-bid/paginate`,
  showLoader: true,
};

export const BID_DELETE = {
  method: 'post',
  url: `${prefix}/dynamic-diamond-bid/delete`,
  showLoader: true,
};

export const CREATE_BID = {
  method: 'post',
  url: `${prefix}/dynamic-diamond-bid/create`,
  showLoader: true,
};

export const UPDATE_BID = {
  method: 'post',
  url: `${prefix}/dynamic-diamond-bid/update`,
  showLoader: true,
};

export const SEEN_STONES = {
  PAGINATE: { method: 'post', url: `${prefix}/hit-counter/paginate` },
};
